var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    { class: _vm.$style.dialog, on: { cancel: _vm.$formCancelHandler } },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v(_vm._s(_vm.hotel.company.name) + " Rates")]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v(
            "See full rate details that can be displayed on the hotel directory for " +
              _vm._s(_vm.hotel.company.name) +
              " below."
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [_c("rate-grid", { attrs: { hotel: _vm.hotel } })],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Close")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }